export const CONNECTOR_KEY = 'fuel-current-connector';
